import { FC, useContext, useEffect, useRef, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import { defaultMapStyle } from '@/layout/ts-config';
// import cs from 'classnames';
import styles from './index.module.less';
// 使用组件库的地图组件，逐步替换
import V2AMap from '@/common/components/Map/V2AMap';
import Legend from './Legend';
import Rail from './Rail';
import BackCore from './BackCore';
// import MarkerCluster from './MapPoint/MarkerCluster';
import CompetitorsMarker from './MapPoint/CompetitorsMarker';
import FamousMarker from './MapPoint/FamousMarker';
import StoreBrandMarker from './MapPoint/StoreBrandMarker';
import CommonRimMarker from './MapPoint/CommonRimMarker';
import cs from 'classnames';
import UserInfoContext from '@/layout/context';
import { debounce } from '@lhb/func';
import { bigdataAction } from '@/common/utils/bigdata';
import { DrawerDataProps } from 'src/views/spotevaluation/pages/index/ts-config';
// import StandardShop from '@/common/components/business/YouthMap/AreaDetailDrawer/components/FirstScreenMap/MapPoint/StandardShop';
import StandardShop from './MapPoint/StandardShop';
import FullScreen from '@/common/components/business/FullScreen';
// import { debounce } from '@lhb/func';
// import { useBigdataFn } from '@/common/utils/bigdata';
export const mapContainer = 'mapContainer';

/**
 * @Description 点位测评详情-地图部分
 */
const FirstScreenMap: FC<{
  mapIns: any;
  detail: any;
  mainHeight;
  legendData: any[];
  isMallType: boolean;
  storeChecked: boolean;
  surroundingChecked: boolean;
  setMapIns: (value: any) => void;
  curDetail, // 经营门店选中的表格项
  setCurDetail, // 设置经营门店选中的表格项
  tenantId,
  drawerData: DrawerDataProps,
  rangeMarkerRef,
  isOpenHeatMap,
  // spotEvaluationConfig: any; // 点位测评配置
  mapDom: any;
  setMapDom: any;
}> = ({
  mapIns,
  detail,
  mainHeight,
  legendData,
  isMallType,
  storeChecked,
  surroundingChecked,
  setMapIns,
  // curSurroundDetail, // 周边配套选中的表格项
  // setCurSurroundDetail, // 设置周边配套选中的表格项
  curDetail, // 经营门店选中的表格项
  setCurDetail, // 设置经营门店选中的表格项
  tenantId,
  drawerData,
  rangeMarkerRef,
  isOpenHeatMap,
  // spotEvaluationConfig,
  mapDom,
  setMapDom,
}) => {
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [isBack, setIsBack] = useState(false);
  const { tenantCheckInfo } = useTenantCheckInfo({ immediate: !tenantId });
  const isALQCommunity = !tenantId && !!tenantCheckInfo?.isALQ;
  const [standardShopData, setStandardShopData] = useState<any[]>([]); // 本品牌门店
  const [famousBrandData, setFamousBrandData] = useState<any[]>([]); // 知名品牌数据
  const [competitorsData, setCompetitorsData] = useState<any[]>([]); // 竞品数据
  const [commonStoreData, setCommonStoreData] = useState<any>({}); // 经营门店
  const [commonRimData, setCommonRimData] = useState<any>({}); // 周边配套数据
  // const [isShowZoom, setIsShowZoom] = useState<boolean>(false);// 是否到展示知名品牌、竞品品牌、经营门店的聚合的级别
  const contentMarkerRef = useRef<any>(null);
  const { mapConfig } = useContext(UserInfoContext); // 租户信息
  const [curZoom, setCurZoom] = useState<number>(12);
  const [curBounds, setCurBounds] = useState<any>();
  const mapContainerRef = useRef<HTMLDivElement>(null);
  const [nameMarkerVisible, setNameMarkerVisible] = useState(true);

  // const isShowCluster = useMemo(() => {
  //   if (!isShowZoom) return false;
  //   const count = (famousBrandData?.length || 0) +
  //   (competitorsData?.length || 0) +
  //   Object.keys(commonStoreData)?.reduce((acc, key) => {
  //     return acc + (commonStoreData[key].length || 0);
  //   }, 0);
  //   // 是否聚合
  //   const isCluster = count > 60 && isShowZoom;
  //   // 如果之前打开了经营门店的context，在聚合级别下不展示
  //   if (isCluster && contentMarkerRef.current?.getExtData()?.isStore) {
  //     mapIns.remove(contentMarkerRef.current);
  //     setCurDetail(null);
  //   }
  //   // 当视图为3km的地图比例尺，且500m以内的经营门店数超过60家则显示小聚合
  //   return isCluster;
  // }, [famousBrandData, competitorsData, commonStoreData, isShowZoom]);

  const handleDetailToNull = () => {
    setCurDetail(null);
    // setCurSurroundDetail(null);
  };
  const methods = useMethods({
    mapLoadedHandle: (ins: any, mapDom: any) => {
      setMapIns(ins);
      setMapDom(mapDom);
      ins.setZooms([12, 20]);
    },
    // 监听地图缩放
    handleZoomEnd() {
      const zoom = mapIns.getZoom();
      // console.log('缩放结束', zoom);
      setCurZoom(zoom);
    },
    // 监听地图移动结束
    handleMoveEnd: debounce(() => {
      const bounds = mapIns?.getBounds?.();
      bounds && setCurBounds(bounds);
      // /spotevaluation/history?modelConfigId=23 查询例如跳转页未配置菜单，写死op_feat，op_menu
      bigdataAction('8cf4cf02-5bd7-417d-a0c2-d762bec53aeb', 'spotEvaluation',
        '点位测评', '详情页-地图拖动', '拖动了详情页-地图', { op_block: '', op_event: '', });
    }, 200),
    // onClickMarker() {
    //   bigdataFn('4e6abada-ed03-4719-b8f6-237cee100584', '详情-地图-点击图标', '点击了详情-地图-点击图标', { op_block: '开店区域-详情页', op_event: ``, });
    // }
  });

  // const handlerZoomEnd = debounce(() => {
  //   bigdataFn('4cf4ecd1-17e0-4f08-bc4f-dd199ef80125', '详情-地图-放大/缩小一次', '详情-地图-放大/缩小一次', { op_block: '开店区域-详情页', op_event: ``, });
  // }, 200);
  // const handlerMoveend = debounce(() => {
  //   // /spotevaluation/history?modelConfigId=23 查询例如跳转页未配置菜单，写死op_feat，op_menu
  //   bigdataAction('8cf4cf02-5bd7-417d-a0c2-d762bec53aeb', 'spotEvaluation',
  //     '点位测评', '详情页-地图拖动', '拖动了详情页-地图', { op_block: '', op_event: '', });
  // }, 200);

  useEffect(() => {
    // 如果curDetail为空，则移出contentMarkerRef
    if (!curDetail) {
      contentMarkerRef.current && mapIns?.remove(contentMarkerRef.current);
    }
  }, [curDetail]);

  useEffect(() => {
    if (!mapIns) return;
    mapIns.setMapStyle(`amap://styles/${mapConfig?.bg || defaultMapStyle}`);
  }, [mapIns, mapConfig]);

  // 埋点注释
  useEffect(() => {
    if (!mapIns) return;
    mapIns.on('zoomend', methods.handleZoomEnd);
    mapIns.on('moveend', methods.handleMoveEnd);
    mapIns.plugin(['AMap.Scale'], () => {
      const scale = new window.AMap.Scale({
        position: 'RB',
        offset: [12, 2],
        // position: {
        //   right: 56,
        //   bottom: 12
        // }
      });
      mapIns.addControl(scale);
    });
    return () => {
      mapIns.off('zoomend', methods.handleZoomEnd);
      mapIns.off('moveend', methods.handleMoveEnd);
    };
  }, [mapIns]);

  return (
    <div className={styles.firstScreenMapCon}>
      <div ref={mapContainerRef} className={cs(styles.mapContainer, mapContainer)}>
        <V2AMap
          mapOpts={{
            zooms: [10, 20],
            showIndoorMap: true,
          }}
          loaded={methods.mapLoadedHandle}
          plugins={[
            'AMap.MarkerCluster',
            'AMap.HeatMap'
          ]}
        >
          {/* 图例 */}
          <Legend
            isALQCommunity={isALQCommunity}
            isMallType={isMallType}
            detail={detail}
            mainHeight={mainHeight}
            legendData={legendData}
            storeChecked={storeChecked}
            setStandardShopData={setStandardShopData}
            surroundingChecked={surroundingChecked}
            setCompetitorsData={setCompetitorsData}
            setFamousBrandData={setFamousBrandData}
            setCommonStoreData={setCommonStoreData}
            setCommonRimData={setCommonRimData}
            tenantId={tenantId}
            drawerData={drawerData}
            isOpenHeatMap={isOpenHeatMap}
            nameMarkerVisible={nameMarkerVisible}
            setNameMarkerVisible={setNameMarkerVisible}
          />
          {/* 商圈围栏以及默认的围栏 */}
          <Rail
            mapIns={mapIns}
            detail={detail}
            isBack={isBack}
            setIsBack={setIsBack}
            rangeMarkerRef={rangeMarkerRef}
            nameMarkerVisible={nameMarkerVisible}
          />
          {/* 回到商圈重心位置 */}
          <BackCore
            setIsBack={setIsBack}
          />
          {/* 全屏 */}
          <FullScreen containerRef={mapContainerRef}/>
          {/* 本品牌门店 */}
          <StandardShop
            mapIns={mapIns}
            legendData={legendData}
            data={isOpenHeatMap ? [] : standardShopData}
            contentMarkerRef={contentMarkerRef}
          />
          {/* 知名品牌 */}
          <FamousMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? [] : famousBrandData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            // onClickMarker={methods.onClickMarker}
          />
          {/* 竞品门店 */}
          <CompetitorsMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? [] : competitorsData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            // onClickMarker={methods.onClickMarker}
          />
          {/* 经营门店（除知名品牌、竞品门店外） */}
          <StoreBrandMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? {} : commonStoreData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            // onClickMarker={methods.onClickMarker}
          />
          {/* 周边配套数据 */}
          <CommonRimMarker
            isALQCommunity={isALQCommunity}
            mapIns={mapIns}
            mapDom={mapDom}
            curZoom={curZoom}
            curBounds={curBounds}
            data={isOpenHeatMap ? {} : commonRimData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            // spotEvaluationConfig={spotEvaluationConfig}
            // onClickMarker={methods.onClickMarker}
          />
          {/* 经营门店点聚合 */}
          {/* <MarkerCluster
            mapIns={mapIns}
            famousBrandData={famousBrandData}
            competitorsData={competitorsData}
            commonStoreData={commonStoreData}
            isShowCluster={isShowCluster}
            setIsShowZoom={setIsShowZoom}
            legendData={legendData}
          /> */}
        </V2AMap>
      </div>
    </div>
  );
};

export default FirstScreenMap;
